import { NSAHomePage, NSARouterMakerResult } from 'namirasoft-account-react';
import { LogLayout } from '../LogLayout';
import { LogProps } from '../LogProps';

interface HomePageProps extends NSARouterMakerResult, LogProps { }

export default function HomePage(props: HomePageProps)
{
    return (
        <LogLayout
            {...props}
        >
            <NSAHomePage
                {...props}
            />
        </LogLayout>
    );
}